export const testimonials = [
  {
    id: 1,
    name: 'James Deng Akol',
    role: 'Business Owner',
    location: 'Thongpiny, Juba',
    rating: 5,
    comment: 'JUWA made finding my dream home incredibly easy. The platform is user-friendly and the agents are very professional. I found the perfect house for my family within two weeks!',
    date: '2025-02-15',
  },
  {
    id: 2,
    name: 'Mary Nyandeng',
    role: 'Teacher',
    location: 'Gudele, Juba',
    rating: 5,
    comment: 'Excellent service! The team at JUWA helped me find an affordable apartment close to my workplace. The entire process was smooth and transparent. Highly recommend!',
    date: '2025-02-10',
  },
  {
    id: 3,
    name: 'Peter Garang',
    role: 'Engineer',
    location: 'Munuki, Juba',
    rating: 5,
    comment: 'As a first-time home buyer, I was nervous about the process. JUWA\'s agents guided me every step of the way. They are knowledgeable, patient, and truly care about their clients.',
    date: '2025-02-08',
  },
  {
    id: 4,
    name: 'Sarah Achol',
    role: 'Entrepreneur',
    location: 'Kator, Juba',
    rating: 5,
    comment: 'I needed commercial space for my business and JUWA delivered! They understood my requirements perfectly and found me the ideal location. Professional service from start to finish.',
    date: '2025-02-05',
  },
  {
    id: 5,
    name: 'David Mayen',
    role: 'Doctor',
    location: 'Jebel, Juba',
    rating: 5,
    comment: 'Outstanding experience! The property listings are detailed and accurate. I appreciated the virtual tours which saved me a lot of time. Found my perfect home thanks to JUWA!',
    date: '2025-02-01',
  },
  {
    id: 6,
    name: 'Grace Awut',
    role: 'Accountant',
    location: 'Hai Cinema, Juba',
    rating: 5,
    comment: 'JUWA is revolutionizing real estate in South Sudan. The platform is modern, efficient, and the customer service is exceptional. I successfully rented out my property within days!',
    date: '2025-01-30',
  },
  {
    id: 7,
    name: 'John Kuol',
    role: 'Lawyer',
    location: 'Hai Malakal, Juba',
    rating: 5,
    comment: 'Professional, reliable, and trustworthy. JUWA helped me sell my property at a great price. The marketing was excellent and the process was hassle-free. Thank you!',
    date: '2025-01-28',
  },
  {
    id: 8,
    name: 'Rebecca Ayen',
    role: 'Nurse',
    location: 'Gudele, Juba',
    rating: 5,
    comment: 'I love how easy it is to search for properties on JUWA. The filters are helpful and the property details are comprehensive. Found my apartment in less than a week!',
    date: '2025-01-25',
  },
];
